import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageShell, PageHero } from "@/components/PageShell";
import { Models } from "@/components/Models";
import { Reveal } from "@/components/Reveal";

export default function ModelsPage() {
  const navigate = useNavigate();

  return (
    <PageShell>
      <PageHero
        testid="page-modeles-hero"
        label="La collection CozyHome"
        title={<>La collection CozyHome, pensée pour <span className="italic text-sage">votre façon de vivre.</span></>}
        sub="Des maisons conçues comme des points de départ à adapter à votre terrain et à votre projet."
      />
      <p data-testid="modeles-phrase" className="bg-ivory px-5 pb-10 text-center font-display text-xl font-medium italic text-navy/80 sm:px-8 sm:text-2xl">
        Nos modèles sont des points de départ. <span className="text-cognac">Votre projet reste le vôtre.</span>
      </p>
      <Models hideHeader />

      <section data-testid="models-custom" className="bg-white pb-20 pt-6 sm:pb-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal>
            <div className="rounded-3xl bg-navy px-8 py-14 text-center sm:px-14 sm:py-16">
              <h2 className="mx-auto max-w-2xl font-display text-3xl font-medium leading-snug text-white sm:text-4xl">
                Aucun modèle ne correspond exactement à votre projet ?{" "}
                <span className="italic text-wood">C'est normal.</span>
              </h2>
              <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-white/65 sm:text-base">
                Une maison ne devrait pas être choisie uniquement dans un catalogue.
                Nos modèles sont là pour vous inspirer et vous aider à définir ce que
                vous aimez : volumes, organisation, style et manière d'habiter. Votre
                terrain, vos besoins et votre budget feront ensuite évoluer le projet.
              </p>
              <button
                data-testid="models-custom-cta"
                onClick={() => navigate("/estimer")}
                className="group mt-8 inline-flex items-center gap-2.5 rounded-full bg-cream px-8 py-4 text-sm font-bold text-navy transition-colors duration-300 hover:bg-cognac hover:text-white"
              >
                Parler de mon projet
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </div>
          </Reveal>
        </div>
      </section>
    </PageShell>
  );
}
